var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fz-12",staticStyle:{"line-height":"18px"}},[_c('p',[_vm._v(_vm._s(_vm.row.operator_name))]),_c('p',{staticClass:"color-gy-7"},[_vm._v(_vm._s(_vm._f("formatDateTime")(_vm.row.add_time)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }